import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { sizeType } from '../../interfaces/enumSizeType';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'rr-checkbox',
  standalone: false,

  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss'
})
export class CheckboxComponent {
  @Input() checked: boolean = false;
  @Input() indeterminate: boolean = false;
  @Input() disabled: boolean = false;
  @Input() size: string = sizeType.Medium;
  @Input() FormControl: FormControl = new FormControl();
  @Input() toggleChecked(): void {
    if (this.disabled === true) return;
    this.checked = !this.checked;
  }
  @Output() checkedChanged = new EventEmitter<boolean>();

  ngOnInit() {

    if (typeof this.FormControl.value == 'boolean') {
      this.checked = this.FormControl.value;
      this.FormControl.valueChanges.subscribe((value) => {
        this.checked = value;
      });
    }
  }
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (this.disabled === true) return;
    this.checked = !this.checked;
    this.checkedChanged.emit(this.checked);
    this.FormControl.setValue(this.checked);
  }

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    if (this.disabled === true) return;
    if (event.key === 'Enter' || event.key === ' ') {
      this.checked = !this.checked;
      this.checkedChanged.emit(this.checked);
      this.FormControl.setValue(this.checked);
    }
  }
}
